<template>
    <b-card v-if="profile">
        <h4>
            Profile
            <b-badge style="float: right"
                v-if="!languages || languages.length &lt; 2">
                <i class="fa fa-id-card-o"></i>
            </b-badge>
            <b-dropdown split style="float: right"
                v-if="languages && languages.length &gt; 1">
                <template slot="button-content">
                    <i class="fa fa-globe" style="font-size: larger"></i>
                </template>
                <b-dropdown-item v-for="l in languages" v-bind:key="l"
                    :selected="selectedLanguage == l"
                    @click="selectedLanguage = l">
                    {{l}}
                </b-dropdown-item>
            </b-dropdown>
        </h4>
        <dl>
        <template cols="*" v-for="f in config" v-if="profile">
            <dt v-bind:key="'l' + f.id">{{selectedLanguage?f.name.i18[selectedLanguage]:f.name.value}}</dt>
            <dd v-bind:key="'v' + f.id"><small>{{ fieldValue(f) || "N/A" }}</small></dd>
        </template>
        </dl>
    </b-card>
</template>

<script>
import axios from "axios";

export default {
    name: "guestProfile",
    props: ["event_id", "guest_id"],
    data: () => {
        return {
            resources: {
                events: "/events",
                guests: "/guests",
                profile: "/profile",
                schema: "/schema"
            },
            profile: undefined,
            config: {},
            selectedLanguage: null
        };
    },
    methods: {
        fetchData(resource, cb) {
            return axios
                .get(resource, {
                    headers: {
                        "Content-Type": "application/json",
                        
                        Authorization: this.$store.getters.accessToken,
                        account_id: this.$store.getters.accountId
                    }
                });
        },
        fieldValue(field) {
            let _v = null;
            if (this.profile[field.id]) {
                if (field.type === "code") {
                    _v = this.profile[field.id];
                } else if (field.type === "date") {
                    _v = this.profile[field.id] ? new Date(this.profile[field.id]).toLocaleString() : null;
                } else if (field.type === "email") {
                    _v = this.profile[field.id];
                } else if (field.type === "file") {
                    _v = this.profile[field.id];
                } else if (field.type === "max_partners") {
                    _v = this.profile[field.id];
                } else if (field.type === "text") {
                    _v = this.profile[field.id];
                } else if (field.type === "select") {
                    if (field.details.options) {
                        _v = field.details.options[this.profile[field.id]].i18[this.selectedLanguage];
                    }
                } else if (field.type === "multiselect") {
                    _v = this.profile[field.id];
                }
            }
            return _v;
        }
    },
    watch: {
        "$route": "fetchData"
    },
    computed: {
        languages() {
            const lng = [];
            if (this.config && this.config[0]) {
                for (let k in this.config[0].name.i18) {
                    lng.push(k);
                    this.selectedLanguage = this.selectedLanguage || k;
                }
            }
            return lng;
        }
    },
    async created() {
        let response = await this.fetchData(this.$store.getters.apiBase + this.$data.resources.events + "/" + this._props["event_id"] +
            this.$data.resources.schema);

        this.$data.config = response.data;

        response = await this.fetchData(this.$store.getters.apiBase + this.$data.resources.events + "/" + this._props["event_id"] +
            this.$data.resources.guests + "/" + this._props["guest_id"] +  this.$data.resources.profile);

        this.$data.profile = response.data;
    }
};
</script>